import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

export default function mailchimpModal() {
  const modal = document.getElementById('mailchimpModal');
  if (!modal) return;

  // Remove inline display:none (FOUC prevention) — CSS takes over from here
  modal.style.removeProperty('display');

  const content = modal.querySelector('.mailchimp-modal__content');
  const form = modal.querySelector('#mc-embedded-subscribe-form');
  const openBtns = document.querySelectorAll('[data-open-mailchimp-modal]');
  const closeBtns = modal.querySelectorAll('[data-close-mailchimp-modal]');
  var triggerElement = null;

  function open() {
    triggerElement = document.activeElement;
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    disableBodyScroll(content);

    var closeBtn = modal.querySelector('.mailchimp-modal__close');
    if (closeBtn) closeBtn.focus();

    document.addEventListener('keydown', handleKeydown);
  }

  function close() {
    modal.setAttribute('aria-hidden', 'true');
    modal.classList.remove('is-open');
    enableBodyScroll(content);
    document.removeEventListener('keydown', handleKeydown);

    if (triggerElement) {
      triggerElement.focus();
      triggerElement = null;
    }
  }

  function handleKeydown(e) {
    if (e.key === 'Escape') {
      close();
    }

    if (e.key === 'Tab') {
      var focusable = modal.querySelectorAll(
        'button:not([tabindex="-1"]), [href], input:not([tabindex="-1"]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      var visibleFocusable = Array.from(focusable).filter(function(el) {
        return el.offsetParent !== null;
      });
      var first = visibleFocusable[0];
      var last = visibleFocusable[visibleFocusable.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  // Clear any previous error styling on a field when the user starts typing
  function clearFieldError(input) {
    input.classList.remove('mailchimp-modal__input--error');
    var error = input.parentNode.querySelector('.mailchimp-modal__error');
    if (error) error.remove();
  }

  // Show inline error on a field
  function showFieldError(input, message) {
    input.classList.add('mailchimp-modal__input--error');
    var existing = input.parentNode.querySelector('.mailchimp-modal__error');
    if (existing) existing.remove();
    var span = document.createElement('span');
    span.className = 'mailchimp-modal__error';
    span.setAttribute('role', 'alert');
    span.textContent = message;
    input.parentNode.appendChild(span);
  }

  // Validate form — returns true if valid
  function validateForm() {
    var valid = true;
    var firstInvalid = null;

    var fname = form.querySelector('#mce-FNAME');
    var lname = form.querySelector('#mce-LNAME');
    var email = form.querySelector('#mce-EMAIL');

    // Clear previous errors
    [fname, lname, email].forEach(function(input) {
      clearFieldError(input);
    });

    if (!fname.value.trim()) {
      showFieldError(fname, 'First name is required.');
      valid = false;
      firstInvalid = firstInvalid || fname;
    }

    if (!lname.value.trim()) {
      showFieldError(lname, 'Last name is required.');
      valid = false;
      firstInvalid = firstInvalid || lname;
    }

    if (!email.value.trim()) {
      showFieldError(email, 'Email address is required.');
      valid = false;
      firstInvalid = firstInvalid || email;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())) {
      showFieldError(email, 'Please enter a valid email address.');
      valid = false;
      firstInvalid = firstInvalid || email;
    }

    if (firstInvalid) firstInvalid.focus();
    return valid;
  }

  // Show a status message in the modal
  function showMessage(type, text) {
    var msgEl = modal.querySelector('.mailchimp-modal__message');
    if (!msgEl) {
      msgEl = document.createElement('div');
      msgEl.className = 'mailchimp-modal__message';
      var fields = form.querySelector('.mailchimp-modal__fields');
      fields.parentNode.insertBefore(msgEl, fields);
    }
    msgEl.className = 'mailchimp-modal__message mailchimp-modal__message--' + type;
    msgEl.setAttribute('role', 'alert');
    msgEl.textContent = text;
  }

  function clearMessage() {
    var msgEl = modal.querySelector('.mailchimp-modal__message');
    if (msgEl) msgEl.remove();
  }

  // Handle form submission via AJAX (JSONP for cross-origin MailChimp)
  function handleSubmit(e) {
    e.preventDefault();
    clearMessage();

    if (!validateForm()) return;

    var submitBtn = form.querySelector('.mailchimp-modal__submit');
    submitBtn.disabled = true;
    submitBtn.textContent = 'Sending...';

    // Build the JSONP URL — swap /post to /post-json and add callback
    var action = form.getAttribute('action');
    var jsonpUrl = action.replace('/post?', '/post-json?') + '&c=mailchimpCallback';

    // Collect form data
    var formData = new FormData(form);
    var params = [];
    formData.forEach(function(value, key) {
      params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    });
    jsonpUrl += '&' + params.join('&');

    // JSONP callback
    window.mailchimpCallback = function(response) {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Sign Up';

      if (response.result === 'success') {
        showMessage('success', 'Thank you for subscribing!');
        form.reset();
      } else {
        // Strip HTML from MailChimp error messages
        var msg = response.msg || 'Something went wrong. Please try again.';
        msg = msg.replace(/<[^>]*>/g, '');
        showMessage('error', msg);
      }

      // Clean up script tag
      var script = document.getElementById('mailchimp-jsonp');
      if (script) script.remove();
      delete window.mailchimpCallback;
    };

    // Create JSONP script
    var script = document.createElement('script');
    script.id = 'mailchimp-jsonp';
    script.src = jsonpUrl;
    script.onerror = function() {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Sign Up';
      showMessage('error', 'Network error. Please try again.');
      delete window.mailchimpCallback;
    };
    document.body.appendChild(script);
  }

  // Bind input listeners for clearing errors on type
  var requiredInputs = form.querySelectorAll('#mce-FNAME, #mce-LNAME, #mce-EMAIL');
  requiredInputs.forEach(function(input) {
    input.addEventListener('input', function() {
      clearFieldError(input);
    });
  });

  if (form) form.addEventListener('submit', handleSubmit);
  openBtns.forEach(function(btn) { btn.addEventListener('click', open); });
  closeBtns.forEach(function(btn) { btn.addEventListener('click', close); });
}
